import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { classNames } from "primereact/utils";

import { primeIcon } from "../icon";
import styles from "./month-range-picker.module.scss";
import { MonthRangePickerPanel } from "./view-panel";
import type { MonthRangePickerViewProps } from "./types-month-range-picker";

/** Ícone do Figma (14) no lugar do PrimeIcons; o Prime entrega as classes `p-button-icon` do botão. */
const CALENDAR_ICON = primeIcon("calendar", 14);

export function MonthRangePickerView({
  panelRef,
  label,
  panelClassName,
  trigger,
  panel,
}: MonthRangePickerViewProps) {
  return (
    <>
      <Button
        type="button"
        id={trigger.id}
        className={trigger.className}
        style={trigger.style}
        icon={CALENDAR_ICON}
        label={label}
        outlined
        severity="secondary"
        disabled={trigger.disabled}
        aria-label={trigger["aria-label"]}
        aria-describedby={trigger["aria-describedby"]}
        aria-invalid={trigger["aria-invalid"]}
        aria-required={trigger["aria-required"]}
        aria-haspopup="dialog"
        onClick={trigger.toggle}
        data-testid={trigger.testId}
        {...trigger.rest}
      />
      <OverlayPanel ref={panelRef} className={classNames(styles.panel, panelClassName)} dismissable>
        <MonthRangePickerPanel {...panel} />
      </OverlayPanel>
    </>
  );
}
